import { supabase } from "@/lib/supabase";

/**
 * Soft-delete companies through Forge's relay.soft_delete_companies command
 * (Glorify-LLC/forgehq-0358a7c6#7668). A direct deleted_at PATCH fails RLS:
 * the stamped row no longer passes the live-row SELECT policy (#163). The
 * command authorizes and deletes the whole batch atomically and returns the
 * number newly deleted (0 for a retry). Never fall back to a direct PATCH if
 * the command is unavailable.
 */
export async function softDeleteCompaniesForOrg(
  organizationId: string | null,
  ids: string[],
): Promise<number> {
  if (ids.length === 0) return 0;
  if (!organizationId) throw new Error("No active organization");
  if (ids.length > 200) throw new Error("Select at most 200 companies to delete together.");
  const { data, error } = await supabase.rpc("soft_delete_companies", {
    p_org_id: organizationId,
    p_ids: ids,
  });
  if (error) {
    if (error.code === "PGRST202" || error.code === "42883") {
      throw new Error("Company deletion is temporarily unavailable. Please try again later.");
    }
    throw error;
  }
  if (typeof data !== "number" || !Number.isSafeInteger(data) || data < 0 || data > new Set(ids).size) {
    throw new Error("Company deletion could not be confirmed. Refresh before trying again.");
  }
  return data;
}
